import axios from "axios";

export const sendMessage = async (id) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_BASEURL}/api/user/whatsapp/send`,{id},{
            headers:{
                "x-access-token":localStorage.getItem("token")
            }
        });
        return response;
    } catch (err) {
        return err.message;
    }
}